import { useTranslation } from 'react-i18next';

import placeholderImage from '../../assets/fashion-product-placeholder.png';

export function SearchPlaceholder() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.Search',
  });
  // Cria 8 cards placeholder (2 linhas de 4)
  const placeholderItems = Array.from({ length: 8 }, (_, index) => (
    <div
      key={index}
      className="flex flex-col rounded-lg border border-solid border-[#E0E0E0]"
    >
      <div className="overflow-hidden rounded-t-lg">
        <img
          src={placeholderImage}
          alt="Fashion search placeholder"
          className="h-auto w-full rounded-t-lg transition-transform duration-300 hover:scale-110"
        />
      </div>
      <div className="h-20 flex-col p-5 font-light">
        <span className="block truncate text-xs font-semibold text-black">
          {t('placeholderProductName')}
        </span>
        <span className="mt-1 block truncate text-xs font-semibold text-black">
          {t('placeholderPrice')}
        </span>
      </div>
    </div>
  ));

  return <div className="grid grid-cols-4 gap-4">{placeholderItems}</div>;
}
